import { render, staticRenderFns } from "./ShowLabel.vue?vue&type=template&id=67c5ae66&"
import script from "./ShowLabel.vue?vue&type=script&lang=js&"
export * from "./ShowLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports